import React from "react";
import { useParams } from "react-router";
import CreateNewBlogContainer from "../../containers/blogs/CreateNewBlog";

const CreateBlogsPage = () => {
  const { id } = useParams();
  return id ? (
    <CreateNewBlogContainer blogId={id} />
  ) : (
    <CreateNewBlogContainer />
  );
};

export default CreateBlogsPage;
